import { useRef, useState, useEffect } from "react";
import { Form, Input, Button, Checkbox, Col, Row, Modal } from "antd";
import useAuth from "../../hooks/useAuth";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "../../api/axios";
import routes from "../../utils/routes";

const LOGIN_URL = "backoffice/auth/authenticate";

const Login = () => {
  const { setAuth, persist, setPersist } = useAuth();

  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || routes.home;
  const [checked, setChecked] = useState();

  const userRef = useRef();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [qrCodeData, setQrCodeData] = useState(null);
  const [temporaryToken, setTemporaryToken] = useState(null);
  const [showPinInput, setShowPinInput] = useState(false);
  const [pin, setPin] = useState("");

  // Add ref for OTP input
  const otpRef = useRef(null);

  useEffect(() => {
    userRef.current.focus();
  }, []);

  useEffect(() => {
    setErrMsg("");
  }, [email, password]);

  // Add effect to focus OTP input when modal opens
  useEffect(() => {
    if (showPinInput && otpRef.current) {
      // Small timeout to ensure modal is fully rendered
      setTimeout(() => {
        const inputElement = otpRef.current.querySelector("input");
        if (inputElement) {
          inputElement.focus();
        }
      }, 100);
    }
  }, [showPinInput]);

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  const handleEmailChange = (value) => {
    setEmail(value);
  };

  useEffect(() => {
    localStorage.setItem("persist", true);
  }, []);

  const handleSubmit = async () => {
    console.log("handleSubmit");
    try {
      console.log(email, " -> ", password);
      const response = await axios.post(
        LOGIN_URL,
        JSON.stringify({ email, password }),
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );
      console.log("after login submit", JSON.stringify(response?.data.data));

      // Handle 2FA flow
      if (response?.data?.data?.qrCode) {
        setQrCodeData(response.data.data.qrCode);
        setTemporaryToken(response.data.data.temporaryToken);
      } else {
        setShowPinInput(true);
        setTemporaryToken(response.data.data.temporaryToken);
      }
    } catch (err) {
      if (!err?.response) {
        setErrMsg("No Server Response");
      } else if (err.response?.status === 400) {
        setErrMsg("Missing Username or Password");
      } else if (err.response?.status === 401) {
        setErrMsg("Unauthorized");
      } else {
        setErrMsg("Login Failed");
      }
      //errRef.current.focus();
    }
  };

  const handleVerifyPin = async () => {
    try {
      const verificationData = {
        email,
        temporaryToken,
        code: parseInt(pin),
      };

      const response = await axios.post(
        "backoffice/auth/verifyTwoFactor",
        verificationData,
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      console.log("after verify pin", JSON.stringify(response));

      const accessToken = response?.data?.data.accessToken;
      const user = response?.data?.data.user;
      setAuth({ accessToken, user, role: user.role });
      setEmail("");
      setPassword("");
      navigate(from, { replace: true });
    } catch (err) {
      setErrMsg("2FA verification failed");
      setShowPinInput(false);
      setPin("");
    }
  };

  const togglePersist = (e) => {
    console.log(`checked = ${e.target.checked}`);
    setPersist(e.target.checked);
  };

  useEffect(() => {
    localStorage.setItem("persist", true);
  }, []);

  // Add new function to handle Enter key press
  const handlePinKeyPress = (e) => {
    if (e.key === "Enter") {
      handleVerifyPin();
    }
  };

  return (
    <div>
      <div
        style={{
          position: "fixed",
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: "-1",
        }}></div>
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: "1",
        }}>
        <h2
          className="header"
          style={{
            color: "#433A3F",
          }}>
          Mahalle Kart Backoffice
        </h2>
        <Row justify="center">
          <Col>
            <Form
              name="login"
              onFinish={handleSubmit}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
              layout="vertical">
              <Form.Item
                label="Email"
                name="email"
                rules={[
                  {
                    required: true,
                    message: "Please fill out your email!",
                  },
                ]}>
                <Input
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                />
              </Form.Item>

              <Form.Item
                label="Password"
                name="password"
                rules={[
                  {
                    required: true,
                    message: "Please fill out your password!",
                  },
                ]}>
                <Input.Password
                  ref={userRef}
                  onChange={(e) => setPassword(e.target.value)}
                  value={password}
                />
              </Form.Item>

              <Form.Item name="remember" valuePropName="checked">
                <Checkbox onChange={togglePersist} checked={checked}>
                  Remember Me
                </Checkbox>
              </Form.Item>

              <Form.Item>
                <Button type="primary" htmlType="submit">
                  Giriş Yap
                </Button>
              </Form.Item>
            </Form>
          </Col>
        </Row>
        <p className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">
          {errMsg}
        </p>
      </div>

      {/* QR Code Modal */}
      <Modal
        title="QR Kod ile Giriş"
        open={qrCodeData !== null}
        onCancel={() => setQrCodeData(null)}
        maskClosable={false}
        footer={[
          <Button
            key="continue"
            type="primary"
            onClick={() => {
              setQrCodeData(null);
              setShowPinInput(true);
            }}>
            Devam Et
          </Button>,
        ]}>
        <div style={{ textAlign: "center" }}>
          <p>
            Lütfen Google Authenticator uygulamasını kullanarak QR kodu okutun.
          </p>
          <img src={qrCodeData} alt="QR Code" style={{ margin: "20px 0" }} />
        </div>
      </Modal>

      {/* PIN Input Modal */}
      <Modal
        title="Doğrulama Kodu"
        open={showPinInput}
        onCancel={() => {
          setShowPinInput(false);
          setPin("");
        }}
        maskClosable={false}
        footer={[
          <Button key="verify" type="primary" onClick={handleVerifyPin}>
            Doğrula
          </Button>,
        ]}>
        <Form layout="vertical">
          <Form.Item
            label="Doğrulama Kodunu Giriniz"
            rules={[
              { required: true, message: "Lütfen doğrulama kodunu giriniz" },
            ]}
            style={{ textAlign: "center" }}>
            <div
              style={{ display: "flex", justifyContent: "center" }}
              ref={otpRef}>
              <Input.OTP
                value={pin}
                onChange={setPin}
                length={6}
                autoFocus
                size="large"
                inputType="numeric"
                inputStyle={{
                  width: 50,
                  height: 50,
                }}
                onKeyPress={handlePinKeyPress}
              />
            </div>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Login;
